import {PrevNext as PrevNextButtons, Title} from "../Sections"

import Container from "../MenuContainer"
import {FilterFood} from "../../utils/filters"
import {useState} from "react"

const Favorites = () => {
    const fruits = FilterFood("Poultry-meat")
    const [scrollValue, setScrollValue] = useState(0)


    return (
        <section className="w-full my-5 px-3 md:px-8 ">
            <div className="w-full flex items-center justify-between">
                <Title title="Обязательно попробуйте"/>
                <PrevNextButtons onNext={() => setScrollValue(10000)} onPrev={() => setScrollValue(-10000)}/>
            </div>
            <Container className="bg-containerbg" scrollOffset={scrollValue} items={fruits}/>
        </section>
    )
}

export default Favorites